import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toggleOilSensor } from 'src/features/deviceSlice';

export const OIL_STATUS = {
  off: 0,
  soji: 1,
  omnicomm: 2
};

const SENSOR_MODEL_LABEL = {
  [OIL_STATUS.soji]: 'Soji',
  [OIL_STATUS.omnicomm]: 'Omnicomm'
};

const getConfirmContent = (currentStatus, nextStatus) => {
  if (nextStatus === OIL_STATUS.off) {
    return 'Bạn có chắc chắn muốn tắt cảm biến xăng dầu?';
  }
  if (currentStatus === OIL_STATUS.off) {
    return 'Bạn có chắc chắn muốn bật cảm biến xăng dầu?';
  }
  return `Bạn có chắc chắn muốn chuyển loại cảm biến sang ${SENSOR_MODEL_LABEL[
    nextStatus
  ] || ''}?`;
};

export default function useOilSensor(d, notifySaved) {
  const dispatch = useDispatch();

  const [oilStatus, setOilStatus] = useState(d.oil_status);
  const [submitting, setSubmitting] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [confirmContent, setConfirmContent] = useState('');
  const [openConfirm, setOpenConfirm] = useState(false);

  const reset = () => {
    setOilStatus(d.oil_status);
    setOpenConfirm(false);
  };

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d.id, d.oil_status]);

  const sendStatus = async status => {
    if (!d.id || submitting || status === oilStatus) return;

    setSubmitting(true);
    const result = await dispatch(
      toggleOilSensor({ id: d.id, data: { status } })
    );
    setSubmitting(false);

    if (toggleOilSensor.fulfilled.match(result)) {
      setOilStatus(status);
      notifySaved();
    }
  };

  // Bật/tắt hoặc đổi loại cảm biến đều mở modal xác nhận, đồng ý mới gọi API
  const requestStatus = status => {
    if (status === oilStatus || submitting) return;
    setPendingStatus(status);
    setConfirmContent(getConfirmContent(oilStatus, status));
    setOpenConfirm(true);
  };

  const isEnabled = oilStatus !== OIL_STATUS.off;

  return {
    isEnabled,
    // Loại cảm biến đang dùng, mặc định Soji khi đang tắt
    sensorModel: isEnabled ? oilStatus : OIL_STATUS.soji,
    submitting,
    onToggle: event =>
      requestStatus(event.target.checked ? OIL_STATUS.soji : OIL_STATUS.off),
    onChangeModel: event => requestStatus(Number(event.target.value)),
    reset,
    confirmDialogProps: {
      title: 'Chú ý',
      content: confirmContent,
      textOk: 'Đồng ý',
      textCancel: 'Hủy',
      open: openConfirm,
      loading: submitting,
      setOpen: value => {
        if (!submitting) setOpenConfirm(value);
      },
      callbackOk: async () => {
        await sendStatus(pendingStatus);
        setOpenConfirm(false);
      }
    }
  };
}
